export class OrcamentoServicoPrintEntity {
  empresa = null;
  itens = [];
  cliente = null;
  meioPagamentoList = [];
  prestadoresList = [];
  modeloImpressao = "A4";

  constructor(
    empresa,
    clienteSelecionado,
    itens,
    servicos,
    pagamentos,
    meioPagamentoList,
    prestadoresList,
    modeloImpressao,
  ) {
    this.empresa = empresa;
    this.cliente = clienteSelecionado ? new Cliente(clienteSelecionado) : null;
    this.itens = itens.map((item) => new Item(item));
    const pagamentosIdsUnicos = Array.from(
      new Set(
        pagamentos.map((s) => s.meioPagamentoId).filter((id) => id != null),
      ),
    );
    this.meioPagamentoList = pagamentosIdsUnicos.map(
      (id) => new MeioPagamento(id, meioPagamentoList),
    );
    const prestadorIdsUnicos = Array.from(
      new Set(
        servicos.map((s) => s.prestadorServicoId).filter((id) => id != null),
      ),
    );
    this.prestadoresList = prestadorIdsUnicos.map(
      (id) => new Prestador(id, prestadoresList),
    );
    this.modeloImpressao = modeloImpressao;
  }
}

class Cliente {
  clienteTelefone = null;
  clienteCelular = null;
  clienteLogradouro = null;
  clienteNumero = null;
  clienteBairro = null;
  clienteCidade = null;
  clienteEstado = null;
  clienteNome = null;

  constructor(cliente) {
    const endereco = cliente?.enderecos?.[0];
    this.clienteLogradouro = endereco?.logradouro || null;
    this.clienteNumero = endereco?.numero || null;
    this.clienteBairro = endereco?.bairro || null;
    this.clienteCidade = endereco?.cidade?.nome || null;
    this.clienteEstado = endereco?.cidade?.estado?.sigla || null;
    this.clienteTelefone = cliente?.telefone || null;
    this.clienteCelular = cliente?.celular || null;
    this.clienteNome = cliente?.nomeRazaoSocial || null;
  }
}

class Item {
  id = null;
  descricao = null;

  constructor(item) {
    this.id = item.id;
    this.descricao = item.descricao;
  }
}

class Prestador {
  id = null;
  nomeRazaoSocial = null;

  constructor(id, prestadoresList) {
    this.id = id;
    const prestador = prestadoresList.find((p) => p.id === id);
    this.nomeRazaoSocial = prestador?.nomeRazaoSocial || null;
  }
}

class MeioPagamento {
  id = null;
  descricao = null;

  constructor(id, meioPagamentoList) {
    this.id = id;
    const meio = meioPagamentoList.find((m) => m.id === id);
    this.descricao = meio?.descricao || null;
  }
}
